module.exports = "/_next/static/images/dfbb8443b8afaa096edafbd74467ed37-rewards-illustration@1x.png";